import React from 'react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import CurrentGoal from './CurrentGoal'
import AncestorInfo from './AncestorInfo'
import Sales from './Sales'
import FinanceEvents from './FinanceEvents'
import News from './News'
import RoadMap from './RoadMap'

import style from './style.module.scss'

class Dashboard extends React.Component {
  state = {
    loading: false
  }

  toggleLoading = loading => this.setState({ loading })

  render() {
    return (
      <div className={style.dashboard}>
        {this.state.loading && (
          <Spin className={style.spinner} size="large" indicator={<LoadingOutlined />} />
        )}
        <CurrentGoal />
        <AncestorInfo />
        <Sales />
        <FinanceEvents />
        <News />
        <RoadMap />
      </div>
    )
  }
}

export default errorBoundaryEnhancer(Dashboard)
